import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    paletaCores4
} from '../../../business-const/Color/Color'

import {
    formataValor,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    incluiAnnotationsPoints
} from '../../../business-components/Chart/ChartService'

import {
    getInfoclientVersoes
} from '../cliente-form/ClienteService'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    processaComparacaoCenariosEstudos,
} from '../estudo-form/EstudoServiceComparacaoCenariosEstudos'

import EstudoFormComparacaoCenariosEstudosTabelaGrafico from '../estudo-form/EstudoFormComparacaoCenariosEstudosTabelaGrafico'



const ComparacaoCenariosEstudosChart = ( { variaveisGlobais, values, handleSubmitAutomatico, estudo, linhaTipoLicenca, jsonConfiguracao,
    jsonPagina, jsonUsuario, jsonUsuarioAdmin, report, comparacaoCenariosEstudosTipo, simulacaoFinanceira, popup,
        selecaoCenarios, indInicial, indFinal, exibirComparacaoCenariosRelatorioSemTabelaGrafico } ) => {

    const [comparacaoCenariosEstudos, setComparacaoCenariosEstudos] = useState(false)
    const [comparacaoCenariosEstudosSeries, setComparacaoCenariosEstudosSeries] = useState(false)
    const [comparacaoCenariosEstudosIdades, setComparacaoCenariosEstudosIdades] = useState(false)
    const [comparacaoCenariosEstudosAnos, setComparacaoCenariosEstudosAnos] = useState(false)

    useSingleton(async () => {

        if (!values.versoesInfoclient && comparacaoCenariosEstudosTipo === HARDCODE.comparacaoCenariosEstudosTipoEstudo) {

            values.versoesInfoclient = await getInfoclientVersoes(variaveisGlobais, values.id, values.versao, linhaTipoLicenca,
                jsonPagina, jsonUsuario, jsonUsuarioAdmin)
        }

        const { comparacaoCenariosEstudosAux, comparacaoCenariosEstudosSeriesAux, comparacaoCenariosEstudosIdadesAux,
            comparacaoCenariosEstudosAnosAux} =
                processaComparacaoCenariosEstudos(variaveisGlobais, values, handleSubmitAutomatico, estudo, report,
                    jsonConfiguracao, comparacaoCenariosEstudosTipo, simulacaoFinanceira)

        setComparacaoCenariosEstudos(comparacaoCenariosEstudosAux)

        setComparacaoCenariosEstudosSeries(comparacaoCenariosEstudosSeriesAux)

        setComparacaoCenariosEstudosIdades(comparacaoCenariosEstudosIdadesAux)

        setComparacaoCenariosEstudosAnos(comparacaoCenariosEstudosAnosAux)
    })

    const ComparacaoCenariosEstudos = ( props ) => {

        let exibirAnnotations = false
        let annotations = JSON.parse(JSON.stringify(HARDCODE.annotationsEstrutura))

        if (simulacaoFinanceira) {

            exibirAnnotations = true

            comparacaoCenariosEstudos?.forEach( (linha, ind) => {

                if (
                        !linha.retiradaMensalDepoisAposentarCliente ||
                        round(linha.retiradaMensalDepoisAposentarCliente, 2) !==
                            linha.retiradaMensalMaximaPreservarReservaAposentadoria ||
                        linha.aporteMensalAdicionalPreservarReservaAposentadoria !== 0) {

                    exibirAnnotations = false

                } else {

                    annotations.points.push(incluiAnnotationsPoints(comparacaoCenariosEstudosSeries[ind].data.length - 5, 
                        comparacaoCenariosEstudosSeries[ind].data[comparacaoCenariosEstudosSeries[ind].data.length - 1],
                            formataValor(round(linha.retiradaMensalDepoisAposentarCliente, 2), 2)))
                }
            })
        }

        const series = []

        series.push(...comparacaoCenariosEstudosSeries)

        const categories = comparacaoCenariosEstudosIdades

        const categories2 = comparacaoCenariosEstudosAnos
        
        const GridGrafico = report && !popup ? GridItem12 : GridItem11

        const dataLabelsDestaque = () => {

            const dataLabelsDestaqueAux = []

            comparacaoCenariosEstudos?.forEach( (item, ind) => {

                dataLabelsDestaqueAux.push(
                    item.idadeVaiAposentarCliente
                )
            })

            return dataLabelsDestaqueAux
        }

        return (
            <div
                {...props}
            >
                <GridGrafico>
                    <ChartPadrao
                        titleText={''}
                        sempreExibirTitleText={true}
                        type="line"
                        series={series}
                        annotations={exibirAnnotations ? annotations : ''}
                        stacked={false}
                        categories={categories}
                        categories2={categories2}
                        paletaCores={paletaCores4}
                        dataLabelsEnabled={true}
                        dataLabelsEnabledReport={true}
                        dataLabelsType='Idade'
                        dataLabelsDestaque={dataLabelsDestaque()}
                        notInverseOrder={true}
                        strokeWidth={1.7}
                        toolTipX={true}
                        toolTipXTotal={false}
                        report={report}
                        formatoReport={values.formatoReport}
                    />
                </GridGrafico>
            </div>
        )
    }

    return (
        comparacaoCenariosEstudos && comparacaoCenariosEstudosSeries &&
        comparacaoCenariosEstudosIdades && comparacaoCenariosEstudosAnos
            ?
                <GridItem12>
                    {(report || simulacaoFinanceira) && !selecaoCenarios
                        ?
                            <>
                                {!indInicial || indInicial === 0
                                    ?
                                        <ComparacaoCenariosEstudos
                                            className='mt-0'
                                        />
                                    :
                                        <br/>
                                }

                                {report && !popup && !exibirComparacaoCenariosRelatorioSemTabelaGrafico && (
                                    <EstudoFormComparacaoCenariosEstudosTabelaGrafico
                                        comparacaoCenariosEstudos={comparacaoCenariosEstudos}
                                        comparacaoCenariosEstudosSeries={comparacaoCenariosEstudosSeries}
                                        comparacaoCenariosEstudosIdades={comparacaoCenariosEstudosIdades}
                                        comparacaoCenariosEstudosAnos={comparacaoCenariosEstudosAnos}
                                        indInicial={indInicial}
                                        indFinal={indFinal}
                                    />
                                )}
                            </>
                        :
                            <CardGridEstudoPadrao
                                label={
                                    !relatorioModoApresentacao(values) || selecaoCenarios
                                        ?
                                            LABEL.evolucaoRecursosFinanceiros
                                        :
                                            HARDCODE.modoApresentacaoRelatorio
                                }
                                component={
                                    <ComparacaoCenariosEstudos/>
                                }
                                overflowX={false}
                            />
                    }
                </GridItem12>
            :
                ''
    )
}

export default ComparacaoCenariosEstudosChart